import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Promotion } from '../models/promotion.model';
import { PromotionInput } from '../models/promotion-input.model';

export interface IPromotionsRepository {
  list(organizationId: number): Observable<readonly Promotion[]>;
  getById(organizationId: number, promotionId: string): Observable<Promotion>;
  create(organizationId: number, input: PromotionInput): Observable<Promotion>;
  update(organizationId: number, promotionId: string, input: PromotionInput): Observable<Promotion>;
  delete(organizationId: number, promotionId: string): Observable<void>;
  duplicate(organizationId: number, promotionId: string): Observable<Promotion>;
}

export const PROMOTIONS_REPOSITORY = new InjectionToken<IPromotionsRepository>('IPromotionsRepository');
